import { useEffect, useState, useRef } from 'react';
import { startLoading, stopLoading } from 'src/utils/loading';
import { showLog } from 'src/utils/debug-log';

const AppRender = ({ children, apiCall }) => {
  showLog('***** App-Render *****');

  const [isRendered, setIsRendered] = useState(false);
  const isMountedRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      if (isMountedRef.current) return;
      isMountedRef.current = true;

      // Start loading
      startLoading();
      try {
        // Call the passed API function (if provided)
        if (apiCall && typeof apiCall === 'function') {
          await apiCall();
        }
        setIsRendered(true);
        // showLog('Data loaded, rendering children.');
      } catch (error) {
        // Stop loading in case of an error
        // showLog('Error occurred, loading stopped.');
      } finally {
        stopLoading();
      }
    };

    // Call fetchData only if apiCall is provided, or manage loading state externally
    fetchData();

    // Cleanup function (optional) to stop loading if the component unmounts
    return () => {
      stopLoading();
    };
  }, [apiCall]);
  
  // Log only once when the component successfully renders children
  // useEffect(() => {
  //   if (isRendered) {
  //     showLog('LOG ONLY ===>>> AppRender: Rendering children.');
  //   }
  // }, [isRendered]);

  if(!isRendered){
    return null;
  }
  return children;
};

export default AppRender;
